import {cms} from "../services/api";

let cached = null;

/**
 * Returns either all homepage attributes (content) or just the specified scope.
 *
 * @example <caption>Whole page reponse (without specifying scope)</caption>
 * {
 *   landing: {
 *     id: 1,
 *     header: "Statut nieumarły"
 *   },
 *   patrons: [{...}]
 *   createdAt: "XXXX-XX-XXTXX:XX:XX.XXXZ"
 * }
 *
 * @example <caption>Response with specified scope ("landing")</caption>
 * {
 *   id: 1,
 *   header: "Statut nieumarły"
 * }
 *
 * @param {string|null} scope The exact scope of the data (attribute) to be returned (for example, "landing").
 * `null` to show all the data. Default: `null`
 * @return {Promise<Object|null>} Homepage data (scoped/unscoped).
 */
export async function getHomepage(scope = null) {
  try {
    if(!cached) {
      const response = await cms.get(`/homepage?populate=*`);
      if(response.status !== 200) {
        return null;
      }

      cached = response.data.data.attributes;
    }

    if(scope == null) {
      return cached;
    }

    if(scope in cached) {
      return cached[scope];
    }

    return null;
  } catch(error) {
    console.error(error);
  }

  return null;
}